module.exports = __webpack_public_path__ + "img/MemeETC (21).360cb705.jpeg";